module.exports = __webpack_public_path__ + "img/bg03.d97224ed.jpg";